import _ from "lodash";

export function parseBoolean(value: string): boolean | null {
  value = value && _.trim(value);
  if (value === "true") {
    return true;
  } else if (value === "false") {
    return false;
  } else {
    return null;
  }
}
